import { render, staticRenderFns } from "./EntityAddRelationship.vue?vue&type=template&id=e02ca466"
import script from "./EntityAddRelationship.vue?vue&type=script&lang=js"
export * from "./EntityAddRelationship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports